import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import styled from 'styled-components';
import { dateConfiguration } from '../../../utils/date';

interface DateStringPickerProps {
  date: {
    start: string;
    end: string;
  };
  onClick: (date: { start: string; end: string }, title: string) => void;
}

const DateStringPicker = (props: DateStringPickerProps) => {
  const { date: dateProps, onClick } = props;

  const onDateComponentClick = (item: { date: { start: string; end: string }; title: string }) => {
    const newObject = Object.assign({}, item);
    onClick(newObject.date, newObject.title);
  };

  const checkIfActive = (item: { date: { start: string; end: string }; title: string }) => {
    return dateProps.start === item.date.start && dateProps.end === item.date.end;
  };

  return (
    <DateStringPickerStyled>
      <div className="d-flex-space-between">
        {dateConfiguration.map(item => (
          <div
            key={item.id}
            className={checkIfActive(item) ? 'date-item is-active' : 'date-item'}
            onClick={() => onDateComponentClick(item)}
          >
            {item.title}
          </div>
        ))}
      </div>
    </DateStringPickerStyled>
  );
};

const DateStringPickerStyled = styled.div`
  .d-flex-space-between {
    display: flex;
    justify-content: space-between;
  }

  .date-item {
    margin: 0 !important;
    flex: 1;
    padding: 6px 12px;
    border: 1px solid #cdced9;
    border-left-color: transparent;
    color: #a7a9bc;
    text-align: center;
    cursor: pointer;
    transition: all 0.25s ease-in-out;
    font-weight: 500;
    font-size: 14px;

    &:hover,
    &:focus {
      background: #ececec;
      transition: all 0.25s ease-in-out;
    }
  }
  .date-item:first-child {
    border-left-color: #cdced9;
    border-radius: 4px 0 0 4px;
  }

  .date-item:last-child {
    border-radius: 0 4px 4px 0;
  }

  .date-item.is-active {
    color: #272833;
    background: #cdced9;
  }
`;

export default DateStringPicker;
